import React from "react";
import { formatNumberToLocal } from "../helpers";
import { CURRENCY_SYMBOLS } from "../Constants";

const CurrencyValue = ({ amount, rate, currency }) => {
  const safeCurrency = currency ?? "CHF";
  const safeRate = rate ?? 1;
  const symbol = CURRENCY_SYMBOLS[safeCurrency] ?? safeCurrency;
  const converted = Number(amount) * Number(safeRate);
  return (
    <span>
      {symbol} {formatNumberToLocal(converted)}
    </span>
  );
};

export default CurrencyValue;
